import axios from "../utils/axios";

export const getPoolById = (payload) => {
    return axios.get(`/Pool/GetById?id=${payload}`);
};
export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};
export const getMaintenanceTypeList = () => {
    return axios.get(`/MaintenanceType/GetList`);
};
export const getBreakDownReasonGroupList = () => {
    return axios.get(`BreakdownReasonGroup/GetListWithTranslated`);
};
export const getPoolRelationById = (payload) => {
    return axios.get(`/Pool/GetRelationsById?poolId=${payload}`);
};
export const editPoolRelation = (payload) => {
    return axios.post(`/Pool/EditRelations`, payload);
};
export const getBreakdownReasonPlaceData = () => {
    return axios.get(`/BreakdownReasonPlace/GetListWithGroup`);
};